module.exports = __webpack_public_path__ + "static/media/22ESCWA5.e39ac1c5.jpg";